module.exports = __webpack_public_path__ + "static/media/slider-right-white.9ed22cdc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/slider-right-white.svg
// module id = 69
// module chunks = 0